import React from 'react';
import Button from '@amzn/awsui-components-core/button';
import Icon from '@amzn/awsui-components-core/icon';
import Popover from '@amzn/awsui-components-core/popover';
import type { ReportStudioState } from 'src/components/star-grid/hooks/useReportStudio';
import { STUDIO_DRAG_TYPE } from 'src/components/star-grid/reportStudioConstants';
import styles from 'src/components/star-grid/components/styles/ReportStudio.module.scss';
interface Props {
  readonly dimension: ReportStudioState['palette']['dimensions'][number];
  readonly state: ReportStudioState;
}
export const StudioPaletteDimension: React.FC<Props> = ({ dimension, state }) => (
  <article
    className={`${styles.paletteItem} ${dimension.usage ? styles.paletteItemUsed : ''} ${!dimension.bindingId ? styles.paletteItemUnavailable : ''}`}
    draggable={Boolean(dimension.bindingId)}
    data-testid={`studio-palette-${dimension.id}`}
    onDragStart={(event) => event.dataTransfer.setData(STUDIO_DRAG_TYPE, JSON.stringify({ kind: 'binding', id: dimension.bindingId }))}
  >
    <span className={styles.paletteName} title={dimension.label}>
      {dimension.label}
    </span>
    {!dimension.unavailableReason && (
      <small className={dimension.usage ? styles.paletteUsage : styles.paletteCount}>{dimension.usage || dimension.memberCount}</small>
    )}
    <div className={styles.paletteActions}>
      <Button
        variant="inline-link"
        disabled={!dimension.bindingId}
        ariaLabel={state.text('studioAddRow')}
        onClick={() => state.addField('rows', dimension.bindingId ?? '')}
      >
        {state.text('studioPaletteRow')}
      </Button>
      <Button
        variant="inline-link"
        disabled={!dimension.bindingId}
        ariaLabel={state.text('studioAddFilter')}
        onClick={() => state.addField('filters', dimension.bindingId ?? '')}
      >
        {state.text('studioPaletteFilter')}
      </Button>
    </div>
    {dimension.unavailableReason && (
      <Popover
        content={dimension.unavailableReason}
        triggerAriaLabel={dimension.availabilityLabel}
        dismissAriaLabel={state.text('studioClose')}
        position="right"
        renderWithPortal
      >
        <Icon name="status-info" />
      </Popover>
    )}
  </article>
);
